var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-conversion-api-test"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("コンバージョンAPI テスト送信")])])],1),_c('ConversionApiTestSystem',{attrs:{"toolId":_vm.toolId,"accountId":_vm.accountId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }